export default __webpack_public_path__ + "static/experienceImg2-f1836e562f2320f3aeab3093c9841b97.webp";